<template>
  <CollapsibleCard :editable="editable && canBeEdited">
    <template v-slot:header> DOKUMENT OCH INTYG </template>

    <template v-slot:info>
      {{ gradeDocs.length + certificateDocs.length + attachmentsDocs.length }} dokument/filer bifogade
    </template>

    <template v-slot:detailsinfo></template>

    <template v-slot:editinfo>Följande filer och dokument är bifogade.</template>

    <template v-slot:view>
      <ApplicationDocumentsView
        :gradeDocs="gradeDocs"
        :attachmentsDocs="attachmentsDocs"
        :certificateDocs="certificateDocs"
        @get-document="getDocument"
      />
    </template>

    <template v-slot:edit>
      <ApplicationDocumentsEdit
        :gradeDocs="gradeDocs"
        :attachmentsDocs="attachmentsDocs"
        :certificateDocs="certificateDocs"
        @get-document="getDocument"
        @saved="$emit('saved')"
      />
    </template>

    <template v-slot:cancel>
      <v-btn color="secondary">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
    </template>

    <template v-slot:save> </template>

  </CollapsibleCard>
</template>

<script>
import MessageBox from '@/components/common/MessageBox.vue'
import CollapsibleCard from '@/components/common/CollapsibleCard'
import {RulesMixin, UserRules, DownloadsMixin} from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'
import filter from 'lodash/filter'
import get from 'lodash/get'
import API from '@/services/api'
import fileDownload from 'js-file-download'
import DialogWithCheckbox from '@/components/common/DialogWithCheckbox.vue'
import ApplicationDocumentsView from './ApplicationDocumentsView.vue'
import ApplicationDocumentsEdit from './ApplicationDocumentsEdit.vue'

// @group Application
// ApplicationDocuments component
export default {
  name: 'ApplicationDocuments',

  mixins: [RulesMixin, UserRules, DownloadsMixin],

  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },

  components: {
    MessageBox,
    CollapsibleCard,
    ApplicationDocumentsView,
    ApplicationDocumentsEdit
  },

  data: () => ({
    gradeDocs: [],
    attachmentsDocs: [],
    certificateDocs: []
  }),

  created() {
    this.getApplicationDocuments()
  },

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'canBeEdited'
    ]),
    ...mapGetters('app', ['isLoading'])
  },

  methods: {
    ...mapActions('application', ['setSelectedApplication']),

    get,

    async getApplicationDocuments() {
      const route = get(this, '$route', null)
      const docs = get(this, 'selectedApplication.applicationDocuments', [])

      if (!route.params.id) return

      this.gradeDocs = filter(docs, ['applicationDocumentType.name', 'Gymnasiebetyg'])
      this.certificateDocs = filter(docs, ['applicationDocumentType.name', 'Övrigt intyg'])
      this.attachmentsDocs = filter(docs, ['applicationDocumentTypeId', 3])
    },

    async getDocument(doc) {
      const shouldSkipDownloadConfirmation = $cookies.get('shouldSkipDownloadConfirmation')

      if (!shouldSkipDownloadConfirmation) {
        const result = await this.$dialog.showAndWait(DialogWithCheckbox, {
          title: 'KÄNSLIG INFORMATION',
          subtitle: 'Filen du vill ladda ned kan innehålla känslig information.',
          text:
            'Det är ditt ansvar att hantera filen med varsamhet och skydda eventuell känslig information och personuppgifter som filen innehåller. <br><br>Vi rekommenderar att du raderar filen från din dator eller enhet så snart som möjligt.',
          label: 'Visa inte detta meddelande igen.',
          width: '576',
          actions: [
            {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
            {text: 'JAG FÖRSTÅR - LADDA NED', key: true, icon: '$sl-check-circle'}
          ]
        })
        if (!(result && result.data)) return
        if (result.checkbox) $cookies.set('shouldSkipDownloadConfirmation', true)
      }

      API.getApplicationDocuments(doc.id)
        .then(response => {
          fileDownload(response.data, doc.fileName, response.headers['content-type'])
        })
        .catch(error => {
          console.log('get document error, ' + doc, error)
        })
    }
  }
}
</script>

<style>
</style>
